<template>
  <b-modal :visible="isOpen"
           lazy
           centered
           ok-variant="ls"
           :title="$t('Choose reward option')"
           @ok="orderReward"
           @hidden="clearModal"
           hide-footer
           size="lg">
    <b-alert :show="warningMessage.length" fade variant="warning">
      <i class="fa fa-lg fa-exclamation-circle"></i>
      {{ warningMessage }}
    </b-alert>

    <input v-if="stateOrder && rewardsVariantsFiltered.length > 0" class="form-control  mr-3 " type="text" :placeholder="$t('Find')" style="max-width: 98%"
           v-model="nameFilter">


    <div v-if="stateOrder" class="form-group " style="max-height: 70vh;margin-bottom: 0px;">
      <div >
        <div v-if="rewardsSorted.length > 0" class="m-content rewards-content ">
          <div v-bind:key="reward.id" v-for="reward in rewardsSorted" class="row reward-variant-row row pb-3 pt-3 " style="min-height: 80px" >
              <div  class="col-md-2 my-auto mx-auto pl-0  pr-0">
                <b-img v-if="reward.picture" :src="reward.picture" width="100" class="my-auto mx-auto" ></b-img>
              </div>
              <div class=" col-md-8 pt-1  pl-0  pr-0" style="overflow: auto">
                <h5><span v-if="reward.points>0" class="font-ls">{{ reward.points }} {{ pointsSymbol }} </span>{{ reward.name }}</h5>
                <div v-if="reward.description && reward.description.length" v-html="reward.description"></div>
              </div>
              <div v-if="ordersEnabled" class="col-md-2 my-auto mx-auto d-flex ">
                <div v-if="!missingPoints(reward)" class="align-self-center mx-auto my-auto pt-3">
                    <button
                        type="button" class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls order-button-text"
                        @click="openOrder(reward)">
                      <span>{{$t('Redeem')}}</span>
                    </button>
                </div>
                <div v-if="missingPoints(reward)" class="mx-auto my-auto">
                  <button type="button" class="btn m-btn--pill m-btn btn-secondary disabled " disabled>
                    {{$t('Missing')}} {{ missingPoints(reward) }} {{pointsSymbol}}
                  </button>
                </div>
              </div>
          </div>
        </div>
        <div v-else>
          {{$t('Lack of rewards option')}}
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import PushIfExists from "@/mixins/pushIfExists";

export default {
  name: "VariantsRewardModal",
  mixins: [PushIfExists],
  data() {
    return {
      SORTING_DATE_ADD_ASC: 0,
      SORTING_DATE_ADD_DESC: 1,
      SORTING_MISSING_POINTS_ASC: 2,
      SORTING_MISSING_POINTS_DESC: 3,
      SORTING_REQUIRED_POINTS_ASC: 4,
      SORTING_REQUIRED_POINTS_DESC: 5,
      SORTING_NAME_ASC: 6,
      SORTING_NAME_DESC: 7,
      nameFilter: '',
      warningMessage: "",
    }
  },
  methods: {
    ...mapActions([
      'setOrder',
      'clearVariantsOrder',
      'clearVariantsOrderModalId',
      'setDigitalOrder',
      'fetchUser',
      'fetchNavigation',
      'setVariantsOrderModalId',
    ]),
    clearModal() {
      this.clearVariantsOrderModalId();
      let timer = setInterval(() => {
        this.clearVariantsOrder();
        this.warningMessage = "";
        this.nameFilter = "";
          clearInterval(timer);
      }, 250);
    },
    missingPoints(reward) {
      if (parseFloat(reward.points) === 0) {
        return 0;
      }
      let missing = parseFloat(reward.points) - parseFloat(this.saldo);

      if (missing <= 0) {
        return 0;
      }

      if (missing === Math.floor(missing)) {
        return Math.floor(missing);
      }

      return missing.toFixed(2);
    },
    openOrder(reward) {
      this.clearModal();
      if(reward.type === '1'){
        this.setDigitalOrder(reward);
      }else if(reward.type === '0'){
        this.setOrder(reward);
      }

    },
    orderReward(e) {
      e.preventDefault();
      this.warningMessage = "";
    },
    sortAsc(a, b, parse = false) {
      if (parse) {
        a = parseInt(a);
        b = parseInt(b);
      }

      if (a > b)
        return 1;
      if (a < b)
        return -1;
      return 0;
    },
    sortDesc(a, b, parse = false) {
      if (parse) {
        a = parseInt(a);
        b = parseInt(b);
      }

      if (a > b)
        return -1;
      if (a < b)
        return 1;
      return 0;
    }
  },
  computed: {
    ...mapState({
      saldo: state => state.auth.user.saldo,
      isOpen: state => state.rewards.variantsOrderModalId !== null,
      rewards: state => state.entityRewards.rewards,
      stateOrder: state => state.rewards.variantsOrder,
      stateUser: state => state.auth.user,
      sorting: state => state.settings.rewardsCatalogSort,
      ordersEnabled: state => state.settings.rewardsOrders === "1",
      pointsConfig: state => state.settings.points,
      pointsSymbol() {
        return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
      },
    }),
    ...mapGetters([
      'getMatchingRoute'
    ]),
    rewardsVariantsFiltered() {
      let filtered = [];
      filtered = this.rewards.filter((r) => this.stateOrder.variants && r.type !== "2" && this.stateOrder.variants.includes(r.id))
      return filtered;
    },
    rewardsFiltered() {
      let filtered = [];
      filtered = this.rewardsVariantsFiltered;
      if (this.nameFilter.length) {
        filtered = this.rewardsVariantsFiltered.filter((r) => r.name.trim().toLowerCase().includes(this.nameFilter.trim().toLowerCase()))
      }
      return filtered;
    },
    rewardsSorted() {
      let cloneDeep = require('lodash.clonedeep');
      let cloneFiltered = cloneDeep(this.rewardsFiltered);

      switch (this.sorting) {
        case this.SORTING_DATE_ADD_ASC:
          return cloneFiltered.sort((a, b) => this.sortAsc(a.id, b.id, true));
        case this.SORTING_DATE_ADD_DESC:
          return cloneFiltered.sort((a, b) => this.sortDesc(a.id, b.id, true));
        case this.SORTING_MISSING_POINTS_ASC:
          return cloneFiltered.sort((a, b) => {
            let aMissing = parseInt(a.points) - parseInt(this.saldo);
            let bMissing = parseInt(b.points) - parseInt(this.saldo);

            return this.sortAsc(aMissing, bMissing)
          });
        case this.SORTING_MISSING_POINTS_DESC:
          return cloneFiltered.sort((a, b) => {
            let aMissing = parseInt(a.points) - parseInt(this.saldo);
            let bMissing = parseInt(b.points) - parseInt(this.saldo);

            return this.sortDesc(aMissing, bMissing)
          });
        case this.SORTING_REQUIRED_POINTS_ASC:
          return cloneFiltered.sort((a, b) => this.sortAsc(a.points, b.points, true));
        case this.SORTING_REQUIRED_POINTS_DESC:
          return cloneFiltered.sort((a, b) => this.sortDesc(a.points, b.points, true));
        case this.SORTING_NAME_ASC:
          return cloneFiltered.sort((a, b) => this.sortAsc(a.name, b.name));
        case this.SORTING_NAME_DESC:
          return cloneFiltered.sort((a, b) => this.sortDesc(a.name, b.name));
      }
    }
  }
}
</script>

<style scoped>

.rewards-content .reward-variant-row:last-child {
  border-bottom: 0!important;
}

.reward-variant-row{
  width: 100%;
  border-bottom: 1px solid #ccc;
  margin-left:0px!important;
}

.btn-secondary.disabled {
  background-color: #f4f5f8;
}
</style>
